const MODULE = "Behaviour Management"
/** Backend may use US or UK spelling for the module display name */
const MODULE_ALIASES = Object.freeze([MODULE, "Behavior Management"])
const BEHAVIOUR_MODULE_ID = 9
const MODULE_DESCRIPTION =
  "Empowers teachers and admins to encourage positive student behavior using a PBIS-style point-based reward system."

const PATHS = Object.freeze({
  SETTINGS: "/behaviour/settings",
  SETTINGS_CORE_VALUE: "/behaviour/settings/core-value",
  SETTINGS_POSITIVE_BEHAVIOURS: "/behaviour/settings/positive-behaviours",
  SETTINGS_AUTOMATED_POINTS: "/behaviour/settings/automated-points",
  SETTINGS_CUSTOMIZED_THEME: "/behaviour/settings/customized-theme",
  POINT_HISTORY: "/behaviour/point-history",
  STUDENT_LIST: "/behaviour/student-list",
  STUDENT_INFO: "/behaviour/student-info"
})

/** Matches `Perpage.vue` default "All entries" option `value` (lazy-style paging). */
const CORE_VALUE_TABLE_ALL_ENTRIES_PER_PAGE = 75

/** Core value row indicator dot colours (Figma); assign server-side later. */
const CORE_VALUE_INDICATOR_COLORS = Object.freeze({
  GREEN: "green",
  BLUE: "blue"
})

const CORE_VALUE_INDICATOR_COLOR_DEFAULT = CORE_VALUE_INDICATOR_COLORS.GREEN

const ROUTE_DEPENDENCY = Object.freeze({
  SETTINGS: "routerDependencies/hasBehaviourSettingsRouteAccess"
})

const BEHAVIOUR_MANAGE_ROLES = ["superadmin", "admin", "teacher", "staff"]
const BEHAVIOUR_ADMIN_ROLES = ["superadmin", "admin"]

export default {
  MODULE,
  MODULE_ALIASES,
  BEHAVIOUR_MODULE_ID,
  MODULE_DESCRIPTION,
  PATHS,
  ROUTE_DEPENDENCY,
  CORE_VALUE_TABLE_ALL_ENTRIES_PER_PAGE,
  CORE_VALUE_INDICATOR_COLORS,
  CORE_VALUE_INDICATOR_COLOR_DEFAULT,
  BEHAVIOUR_MANAGE_ROLES,
  BEHAVIOUR_ADMIN_ROLES
}
